import {
  GET_TEMPLATE_LIST,
  SET_TEMPLATE_LIST,
  GET_TEMPLATE_LIST_FAILURE,
  DELETE_TEMPLATE_SUCCESS,
  UPSERT_TEMPLATE,
} from './actions';

const initialState = {
  templates: [],
  loading: false,
  error: null,
};

export default function templateReducer(state = initialState, action) {
  switch (action.type) {
    case GET_TEMPLATE_LIST:
      return { ...state, loading: true, error: null };
    case SET_TEMPLATE_LIST:
      return { ...state, templates: action.payload, loading: false };
    case GET_TEMPLATE_LIST_FAILURE:
      return { ...state, error: action.payload, loading: false };
    case DELETE_TEMPLATE_SUCCESS:
      return {
        ...state,
        templates: state.templates.filter((t) => t.id !== action.payload),
      };
    case UPSERT_TEMPLATE:
      const index = state.templates.findIndex(
        (t) => t.id === action.payload.id
      );
      if (index >= 0) {
        return {
          ...state,
          templates: [
            ...state.templates.slice(0, index),
            action.payload,
            ...state.templates.slice(index + 1),
          ],
        };
      } else {
        return {
          ...state,
          templates: [...state.templates, action.payload],
        };
      }
    default:
      return state;
  }
}
